import React, { useEffect, useState } from 'react';
import { Button, Col, Icon } from '../../../../components/Component';
import { Card } from 'reactstrap';
import { formatNumber } from '../../../../utils/Utils';
import moment from 'moment';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const SalesRepDetailsOrdersReportsSummary = ({ start_date, end_date, data }) => {

  const [page_data, setPageData] = useState([]);
  const [date_range, setDateRange] = useState({ start_date: start_date, end_date: end_date });

  useEffect(() => {
    setDateRange({ start_date: start_date, end_date: end_date });
    setPageData(data);
  }, [start_date, end_date, data]);

  const summaryStats = [
    {
      label: "Total Orders",
      value: page_data?.total_number_of_orders || "0",
      icon: "cart",
      color: "#3b82f6",
      bg: "#eff6ff",
    },
    {
      label: "Total Dispatches",
      value: page_data?.total_number_of_dispatches || "0",
      icon: "truck",
      color: "#3b82f6",
      bg: "#eff6ff",
    },
    {
      label: "Dispatches in Selected Range",
      value:
        page_data?.total_number_of_dispatches_within_selected_date_range || "0",
      icon: "calendar",
      color: "#3b82f6",
      bg: "#eff6ff",
    },
    {
      label: "Total Products",
      value: page_data?.total_products || "0",
      icon: "package",
      color: "#16a34a",
      bg: "#f0fdf4",
    },
    {
      label: "Total Units",
      value: page_data?.total_units || "0",
      icon: "layers",
      color: "#16a34a",
      bg: "#f0fdf4",
    },
    {
      label: "Total Unit Value",
      value: `${formatNumber(page_data?.total_products_unit_value) || "0"} ZMW`,
      icon: "coins",
      color: "#16a34a",
      bg: "#f0fdf4",
    },
    {
      label: "Products in Selected Range",
      value: page_data?.total_products_within_range || "0",
      icon: "package",
      color: "#64748b",
      bg: "#f8fafc",
    },
    {
      label: "Units in Selected Range",
      value: page_data?.total_units_within_range || "0",
      icon: "layers",
      color: "#64748b",
      bg: "#f8fafc",
    },
    {
      label: "Unit Value in Selected Range",
      value:
        `${formatNumber(page_data?.total_products_unit_value_within_range) || "0"} ZMW`,
      icon: "coins",
      color: "#64748b",
      bg: "#f8fafc",
    },
    {
      label: "Total Units Dispatched",
      value: page_data?.total_units_dispatched || "0",
      icon: "truck",
      color: "#3b82f6",
      bg: "#eff6ff",
    },
    {
      label: "Total Dispatched Value",
      value:
        `${formatNumber(page_data?.total_units_dispatched_value) || "0"} ZMW`,
      icon: "coins",
      color: "#16a34a",
      bg: "#f0fdf4",
    },
    {
      label: "Units Dispatched in Selected Range",
      value:
        page_data?.total_units_dispatched_within_range || "0",
      icon: "calendar",
      color: "#64748b",
      bg: "#f8fafc",
    },
    {
      label: "Dispatched Value in Selected Range",
      value:
        `${formatNumber(page_data?.total_units_dispatched_value_within_range) || "0"} ZMW`,
      icon: "coins",
      color: "#64748b",
      bg: "#f8fafc",
    },
  ];

  // Export to CSV
  const export_to_csv = (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    const csv_headers = [
      "Total Orders",
      "Total Dispatches",
      "Total Products",
      "Total Units",
      "Total Unit Value (ZMW)",
      "Products in Selected Date Range",
      "Units in Selected Date Range",
      "Unit Value in Selected Date Range (ZMW)",
      "Dispatches in Selected Date Range",
      "Total Units Dispatched",
      "Total Units Dispatched Value (ZMW)",
      "Total Units Dispatched in Selected Date Range",
      "Total Units Dispatched Value in Selected Date Range"
    ];

    const csv_data = [{
      total_number_of_orders: page_data?.total_number_of_orders,
      total_dispatches: page_data?.total_number_of_dispatches,
      total_products: page_data?.total_products,
      total_units: page_data?.total_units,
      total_products_unit_value: formatNumber(page_data?.total_products_unit_value) || 0.00,
      total_products_within_range: page_data?.total_products_within_range,
      total_units_within_range: page_data?.total_units_within_range,
      total_products_unit_value_within_range: formatNumber(page_data?.total_products_unit_value_within_range) || 0.00,
      total_number_of_dispatches_within_selected_date_range: page_data?.total_number_of_dispatches_within_selected_date_range,
      total_units_dispatched: page_data?.total_units_dispatched,
      total_units_dispatched_value: formatNumber(page_data?.total_units_dispatched_value) || 0.00,
      total_units_dispatched_within_range: page_data?.total_units_dispatched_within_range,
      total_units_dispatched_value_within_range: formatNumber(page_data?.total_units_dispatched_value_within_range) || 0.00,
    }
    ];

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `${page_data?.sales_rep?.name}'s Order Report Summary from ${date_range?.start_date} to ${date_range?.end_date} as at ${cur_dt}`,
      useKeysAsHeaders: true,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(csv_data || []);

    download(options)(csv);

  };


  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <Button
          color="primary"
          className="btn-primary"
          onClick={export_to_csv}
        >
          <Icon name="download-cloud" />
          <span>Export to CSV</span>
        </Button>
      </div>
      {/* Stats Cards */}
      {summaryStats?.map((stat, idx) => (
        <Col key={idx} xxl="3" sm="6">
          <Card
            style={{
              borderRadius: "8px",
              border: "1px solid #e5e9f2",
              transition: "all 0.3s ease",
              marginBottom: 0,
              height: "100%",
            }}
          >
            <div style={{ padding: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                  <h6 style={{ fontSize: "14px", color: "#6c757d", marginBottom: "8px" }}>
                    {stat.label}
                  </h6>
                  <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                    {stat.value}
                  </h2>
                </div>
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    backgroundColor: stat.bg,
                  }}
                >
                  <Icon name={stat.icon} style={{ color: stat.color }} />
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default SalesRepDetailsOrdersReportsSummary;